import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-D_LIh_94.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const CartOutlinedSize16Component = (props, ref) => (jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.18975 2.0615L11.6854 5.33077H4.31463L6.81025 2.0615L5.8564 1.33337L2.80496 5.33077H0L0.490456 10.309H0.492103C0.865836 13.5697 2.28869 14.6641 6.07792 14.6641H9.92208C13.7113 14.6641 15.1342 13.5697 15.5079 10.309H15.5095L16 5.33077H13.195L10.1436 1.33337L9.18975 2.0615ZM1.68429 10.1724C1.85653 11.6751 2.23997 12.3726 2.74078 12.762C3.28697 13.1867 4.24381 13.4641 6.07792 13.4641H9.92208C11.7562 13.4641 12.713 13.1867 13.2592 12.762C13.76 12.3726 14.1435 11.6751 14.3157 10.1724L14.676 6.53077H1.32403L1.68429 10.1724Z", fill: "var(--magritte-ui-icon-color)" }) }) }));
const CartOutlinedSize16 = hoc(forwardRef(CartOutlinedSize16Component), 'CartOutlinedSize16');

export { CartOutlinedSize16 as default };
//# sourceMappingURL=CartOutlinedSize16.js.map
